import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface WorldSummary {
	id: string;
	ownerId: string;
	slug: string;
	name: string;
	version: string | null;
	foundryId?: string | null;
	systemType: string;
	status: string;
	systemRulesetId: string;
	eraId: string;
	era: string;
	techLevelId: string;
	techLevel: string;
	dominantCultureId?: string | null;
	dominantCulture: string | null;
	mapAssetId: string | null;
	pdfAssetId: string | null;
	mapAttribution: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface WorldOptionsResponse {
	options: {
		systems: Array<{ id: string; name: string }>;
		eras: Array<{ id: string; name: string }>;
		techLevels: Array<{ id: string; name: string }>;
		cultures?: Array<{ id: string; name: string }>;
	};
}

export interface WorldsListResponse extends WorldOptionsResponse {
	worlds: WorldSummary[];
}

export interface WorldGetResponse extends WorldOptionsResponse {
	world: WorldSummary;
	worlds: WorldSummary[];
}

export interface CreateWorldRequest {
	name: string;
	systemRulesetId: string;
	eraId: string;
	techLevelId: string;
}

export interface UpdateWorldRequest {
	name: string;
	version?: string | null;
	systemRulesetId: string;
	eraId: string;
	techLevelId: string;
	status?: string | null;
	dominantCulture?: string | null;
	dominantCultureId?: string | null;
	mapAssetId?: string | null;
	pdfAssetId?: string | null;
	mapAttribution?: string | null;
}

export interface CreateWorldResponse {
	world: WorldSummary;
}

@Injectable({ providedIn: 'root' })
export class WorldsService {
	constructor(private readonly http: HttpClient) {}

	list(): Observable<WorldsListResponse> {
		return this.http.get<WorldsListResponse>(`${environment.api.baseUrl}/v1/worlds`);
	}

	get(worldId: string): Observable<WorldGetResponse> {
		return this.http.get<WorldGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}`);
	}

	create(request: CreateWorldRequest): Observable<CreateWorldResponse> {
		return this.http.post<CreateWorldResponse>(`${environment.api.baseUrl}/v1/worlds`, {
			Name: request.name,
			SystemRulesetId: request.systemRulesetId,
			EraId: request.eraId,
			TechLevelId: request.techLevelId,
		});
	}

	update(worldId: string, request: UpdateWorldRequest): Observable<{ world: WorldSummary }> {
		return this.http.put<{ world: WorldSummary }>(`${environment.api.baseUrl}/v1/worlds/${worldId}`, {
			Name: request.name,
			SystemRulesetId: request.systemRulesetId,
			EraId: request.eraId,
			TechLevelId: request.techLevelId,
			Status: request.status ?? null,
			Version: request.version ?? null,
			DominantCultureId: request.dominantCultureId ?? null,
			DominantCulture: request.dominantCulture ?? null,
			MapAssetId: request.mapAssetId ?? null,
			PdfAssetId: request.pdfAssetId ?? null,
			MapAttribution: request.mapAttribution ?? null,
		});
	}
}
